// Copyright (c) 2016 Deere & Company

import LaborPanelContainer from './labor-panel-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    errors: state.claims.track.claim.errors,
    isEditable: state.claims.track.isEditable,
    laborLocations: state.claims.laborLocations,
    laborTypes: state.claims.laborTypes,
    labors: state.claims.track.claim.labor
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(LaborPanelContainer);



// WEBPACK FOOTER //
// ./src/claim/track/components/labors-panel/index.js